import React from 'react';
import Modal from 'react-modal';

import modal from '../../../definitions/Modal';
import { formatCustom, formatTime } from '../../../utils/TimeUtils';
import { FormattedMessage } from 'react-intl';
import Row from '../../tag/Row';
import Span from '../../tag/Span';
import OTButton from '../../tag/OTButton';
import Loader from '../../Loader';
import OTButtonGroup from '../../tag/OTButtonGroup';

const style = modal({ content: { width: '400px', textAlign: 'left' } });

let { id: module_id } = module;

const AppointmentReserveConfirmModal = ({
  modalIsOpen,
  closeModal,
  confirmTime,
  isReserving,
  item,
}) => {
  let loader = null;
  let { comment: reason, selectedTime, selectedClinicKey } = item;

  if (isReserving) {
    loader = <Loader />;
  }

  return (
    <Modal
      ariaHideApp={false}
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={style}
      contentLabel=""
    >
      <Row>
        <Span>
          <h4 className="float-left ot-modal__title">
            <FormattedMessage id={`${module_id}.reserve.appointment`} />
          </h4>
        </Span>
      </Row>
      <Row>
        <Span len="4" sm-len="12">
          <span className="appointment-modal-label">
            <FormattedMessage id={`${module_id}.appointment.type`} />
          </span>
        </Span>
        <Span len="8" sm-len="12">
          <span className="appointment-modal-text">
            <FormattedMessage id={reason} />
          </span>
        </Span>
      </Row>
      <Row>
        <Span len="4" sm-len="12">
          <span className="appointment-modal-label">
            <FormattedMessage id={`${module_id}.location`} />
          </span>
        </Span>
        <Span len="8" sm-len="12">
          <span className="appointment-modal-text">
            <FormattedMessage id={selectedClinicKey + '.location'} />
          </span>
        </Span>
      </Row>
      <Row>
        <Span len="4" sm-len="12">
          <span className="appointment-modal-label">Uusi aika</span>
        </Span>
        <Span len="8" sm-len="12">
          {/* Here it is assumed that dates do not span over days */}
          <span className="appointment-modal-text">
            {`${formatCustom(
              selectedTime.dateStart,
              'DD. MMMM'
            )}ta klo ${formatTime(selectedTime.dateStart)} - ${formatTime(
              selectedTime.dateEnd
            )}`}
          </span>
        </Span>
      </Row>
      <Row>{loader}</Row>
      <Row>
        <OTButtonGroup type={'big'} fullWidth collapseOnMobile>
          <OTButton
            disabled={isReserving}
            type="big"
            color={'gray'}
            onClick={closeModal}
            message={'back'}
          />
          <OTButton
            disabled={isReserving}
            type="big"
            onClick={confirmTime}
            message={'OK'}
          />
        </OTButtonGroup>
      </Row>
    </Modal>
  );
};

Modal.setAppElement('body');
export default AppointmentReserveConfirmModal;
